/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-misused-promises */
import {
  Button,
  Combobox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea
} from "@repo/ui";
import React, { useContext, useEffect, useRef, useState } from "react";
import type { UseFormReturn } from "react-hook-form";
import { useForm, useFieldArray } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { LookUpContext } from "utils/reducers/lookup";
import type { BagType, CoinsDenom, Currency } from "utils/types/lookup.type";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { LucideFileEdit, PlusCircle, TrashIcon } from "lucide-react";
import {
  useAutocompleteAllLocations,
  useGetAllBagTypes
} from "utils/apis/lookups.api";
import {
  BAG_COINS_DENOMINATIONS,
  BOX_COINS_DENOMINATIONS,
  SEAL_NUMBER_REGEX
} from "utils/constant";
import SearchableDropdown from "components/searchableDropdown";

const formSchema = z
  .object({
    consignmentType: z
      .string()
      .min(1, { message: "Consignment Type is required." }),
    containerType: z.string().min(1, { message: "Bag Type is required." }),
    containerId: z.string().min(1, { message: "ContainerId is required." }),
    details: z.string(),
    currency: z.string().optional(),
    chequePieces: z.number().optional(),
    sourceSPId: z.string().optional(),
    declaredValue: z
      .number()
      .min(0, { message: "Declared Value can not be negative." }),
    exchangeRate: z
      .number()
      .min(0.001, { message: "Exchange Rate is required." }),
    count: z.number().min(1, { message: "Count is required." }),
    sealNo: z.string().optional(),
    remarks: z.string().optional(),
    packedCurrencies: z.array(
      z.object({
        currency: z.string(),
        declaredValue: z.number(),
        exchangeRate: z.number()
      })
    ),
    denominations: z.array(
      z.object({
        denomination: z.string(),
        shape: z.string(),
        count: z.number()
      })
    ),
    sourceLocationBarcode: z.string().optional(),
    sourceLocationName: z.string().optional()
  })
  .superRefine((data, ctx) => {
    if (!data.sealNo && data.consignmentType !== "Coins") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["sealNo"],
        message: "Seal no. is required"
      });
      return true;
    }

    if (!data.details && data.consignmentType === "Coins") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["details"],
        message: "Coin Denomination is required"
      });
      return true;
    }

    if (data.sealNo && !SEAL_NUMBER_REGEX.test(data.sealNo)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["sealNo"],
        message: "Invalid seal no. format."
      });
      return true;
    }

    if (
      !["Foreign Currency", "ATM Cassette FC"].includes(data.containerType) &&
      !data.currency
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["currency"],
        message: "Currency is required"
      });
      return true;
    }

    if (
      ["Foreign Currency", "ATM Cassette FC"].includes(data.containerType) &&
      data.packedCurrencies.length === 0
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["packedCurrencies"],
        message: "Packed Currencies is required for FC Bag Type."
      });
      return true;
    }
  });

const defaultValues = {
  consignmentType: "",
  containerType: "",
  containerId: "",
  details: "",
  currency: "",
  declaredValue: 0,
  exchangeRate: 1,
  count: 1,
  sealNo: "",
  remarks: "",
  chequePieces: 0,
  packedCurrencies: [],
  denominations: [],
  sourceSPId: "",
  sourceLocationBarcode: "",
  sourceLocationName: ""
};
export default function AddConsignment({
  onConfirm,
  isLoading,
  isSuccess,
  bags,
  type,
  isEdit,
  defaultBagType,
  isTGDelivery
}: {
  onConfirm: (data: any) => void;
  isLoading: boolean;
  isSuccess: boolean;
  isEdit?: boolean;
  bags: any;
  type:
    | "B2B"
    | "Delivery"
    | "Kiosk Service"
    | "Replenishment"
    | "Clearance"
    | "Collection"
    | "Exchange"
    | "InterBranch";
  defaultBagType: string;
  isTGDelivery: boolean;
}) {
  const { currencies, coinContainers } = useContext(LookUpContext);
  const [openAddConsignment, setOpenAddConsignment] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [consignments, setConsignments] = useState<any[]>([]);
  const [editId, setEditId] = useState<string | null>(null);
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues
  });

  const isCurrencyDisabled = useRef(false);
  const { control } = form;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "packedCurrencies"
  });

  const { data: autocompleteResults = [], isFetching: isFetchingAutocomplete } =
    useAutocompleteAllLocations(searchTerm);
  const { data: allBagTypes } = useGetAllBagTypes(type);
  const consignmentType = form.watch("consignmentType");
  const containerType = form.watch("containerType");

  const handleChangeSourceLocation = (val: string) => {
    const selectedLocation = autocompleteResults?.find(
      (i: any) => i.servicePointId === val
    );
    if (selectedLocation) {
      form.setValue("sourceLocationBarcode", selectedLocation.barcode);
      form.setValue("sourceLocationName", selectedLocation.locationName);
    }
  };
  const handleChangeBagType = (val: string) => {
    const selectedBag = (allBagTypes as BagType[])?.find(
      (i) => i.description === val
    );
    if (selectedBag) {
      form.setValue("consignmentType", selectedBag.consignmentType);
      form.setValue("containerId", String(selectedBag.code));
      if (
        selectedBag.consignmentType === "Coins" ||
        selectedBag.currencyType === "AED"
      ) {
        form.setValue("currency", "AED");
        isCurrencyDisabled.current = true;
      } else {
        isCurrencyDisabled.current = false;
      }
    }
  };

  const handleChangeCurrency = (val: string) => {
    const selectedCurr = (currencies as Currency[])?.find(
      (i) => i.shortName === val
    );
    if (selectedCurr) {
      form.setValue("exchangeRate", selectedCurr?.exchangeRate || 1);
    }
  };

  function onSubmit(values: z.infer<typeof formSchema>) {
    if (["Foreign Currency", "ATM Cassette FC"].includes(containerType)) {
      values.currency = "FC";
      values.exchangeRate = 1;
      values.declaredValue = values.packedCurrencies?.reduce(
        (acc, curr) => acc + (curr.declaredValue * curr.exchangeRate || 0),
        0
      );
    }
    if (values.consignmentType === "Coins") {
      values.sealNo = "";
      const selectedCoin = (coinContainers as CoinsDenom[])?.find(
        (i) =>
          i.denomination === values.details && i.containerType === containerType
      );
      if (selectedCoin) {
        values.declaredValue = selectedCoin?.valuePerContainer * values.count;
      }
    }

    if (
      !editId &&
      values.sealNo &&
      consignments?.find((i) => i.sealNo === values.sealNo)
    ) {
      form.setError("sealNo", {
        message: "Seal no. already scanned"
      });
      return true;
    }

    if (isTGDelivery && !values.sourceSPId) {
      form.setError("sourceSPId", {
        message: "Source Location is required for TG delivery"
      });
      return true;
    }

    if (editId) {
      const filterContainerData = consignments?.map((item) => {
        if (item?.deleteId === editId) {
          return { ...values, deleteId: item?.deleteId };
        }
        return item;
      });

      setConsignments(filterContainerData);
      setEditId(null);
    } else {
      setConsignments((prev) => [
        ...prev,
        { ...values, deleteId: crypto.randomUUID() }
      ]);
    }

    form.reset({
      ...defaultValues,
      consignmentType: values.consignmentType,
      containerType: values.containerType,
      containerId: values.containerId,
      sourceLocationBarcode: values.sourceLocationBarcode,
      sourceLocationName: values.sourceLocationName,
      sourceSPId: values.sourceSPId,
      currency: values.currency === "FC" ? "" : values.currency
    });
  }

  const onAssignBags = () => {
    onConfirm(consignments);
  };

  const handleMultipleCurrencyAppend = () => {
    const currency = form.getValues("currency");
    const isCurrencyAlreadyAdded = form
      .getValues("packedCurrencies")
      ?.some((item) => item.currency === currency);

    if (currency && !isCurrencyAlreadyAdded) {
      append({
        currency,
        exchangeRate: form.getValues("exchangeRate"),
        declaredValue: form.getValues("declaredValue")
      });
    } else if (isCurrencyAlreadyAdded) {
      form.setError("currency", {
        message: "Currency already added in the FC list."
      });
    } else {
      form.setValue("currency", "");
      form.setValue("exchangeRate", 1);
      form.setValue("declaredValue", 0);
    }
  };

  function ActionCell(props: any) {
    const { dataItem } = props;

    const handleDelete = (id: string) => {
      let filterContainerData = consignments?.slice();
      filterContainerData = filterContainerData?.filter(
        (item) => item?.deleteId !== id
      );
      setConsignments(filterContainerData);
    };

    const handleEdit = (id: string) => {
      const filterContainerData = consignments?.find(
        (item) => item?.deleteId === id
      );
      if (filterContainerData) {
        if (filterContainerData.currency === "FC") {
          form.reset({
            ...filterContainerData,
            currency: "",
            declaredValue: 0,
            sourceLocationBarcode:
              filterContainerData?.sourceLocationBarcode || "",
            sourceLocationName: filterContainerData?.sourceLocationName || "",
            sourceSPId: filterContainerData?.sourceSPId || ""
          });
        } else {
          form.reset({
            ...filterContainerData,
            sourceLocationBarcode:
              filterContainerData?.sourceLocationBarcode || "",
            sourceLocationName: filterContainerData?.sourceLocationName || "",
            sourceSPId: filterContainerData?.sourceSPId || ""
          });
        }
        setEditId(id);
      }
    };

    return (
      <td {...props}>
        <div className="flex gap-1">
          <Button variant="ghost" size="icon" type="button">
            <LucideFileEdit
              className="text-secondary"
              onClick={() => {
                handleEdit(dataItem?.deleteId);
              }}
            />
          </Button>
          <Button variant="ghost" size="icon" type="button">
            <TrashIcon
              className="text-red-500"
              onClick={() => {
                handleDelete(dataItem?.deleteId);
              }}
            />
          </Button>
        </div>
      </td>
    );
  }

  useEffect(() => {
    if (isSuccess) {
      setOpenAddConsignment(false);
      form.reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    if (bags?.length && openAddConsignment) {
      setConsignments(
        bags?.map((item: any) => ({
          ...item,
          deleteId: crypto.randomUUID()
        }))
      );
    }
  }, [bags, openAddConsignment]);

  useEffect(() => {
    if (defaultBagType && allBagTypes?.length) {
      form.setValue("containerType", defaultBagType);
      handleChangeBagType(defaultBagType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultBagType, allBagTypes]);

  useEffect(() => {
    if (searchTerm && searchTerm?.length < 5) {
      form.setValue("sourceSPId", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  function DeleteCell(props: any) {
    const { dataIndex } = props;
    return (
      <td {...props}>
        <TrashIcon
          className="text-red-500 cursor-pointer"
          type="button"
          onClick={() => {
            remove(dataIndex);
          }}
        />
      </td>
    );
  }

  return (
    <div>
      <Button
        onClick={() => {
          setOpenAddConsignment(true);
        }}
      >
        {isEdit ? "Edit Consignment" : "Add Consignment"}
      </Button>
      <Dialog
        open={openAddConsignment}
        onOpenChange={(val) => {
          // setOpenAddConsignment(false);
          setOpenAddConsignment(val);
          form.reset(defaultValues);
          setSearchTerm("");
          if (!val) setConsignments([...bags]);
        }}
      >
        <DialogContent className="max-w-[980px] w-full">
          <DialogHeader>
            <DialogTitle>Bag Assignment</DialogTitle>
          </DialogHeader>
          <DialogDescription className="max-w-[980px] w-full max-h-[80vh] overflow-auto">
            <Form {...form}>
              <form
                id="collection-form"
                onSubmit={form.handleSubmit(onSubmit)}
                className="gap-4 grid grid-cols-2"
              >
                {isTGDelivery ? (
                  <FormField
                    control={form.control}
                    name="sourceSPId"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Source Location</FormLabel>
                        <SearchableDropdown
                          value={field.value}
                          searchTerm={searchTerm}
                          onSearchChange={setSearchTerm}
                          data={
                            autocompleteResults?.map((item: any) => ({
                              value: item.servicePointId,
                              label: `${item.barcode || ""}-${item.locationId}`
                            })) || []
                          }
                          loading={isFetchingAutocomplete}
                          onChange={(val) => {
                            field.onChange(val);
                            handleChangeSourceLocation(val);
                          }}
                        />

                        <FormMessage />
                      </FormItem>
                    )}
                  />
                ) : null}
                <FormCombobox
                  form={form}
                  data={allBagTypes?.map((item: BagType) => ({
                    label: item?.description,
                    value: item?.description
                  }))}
                  name="containerType"
                  label="Bag Type"
                  placeholder="Select Bag Type"
                  onChange={handleChangeBagType}
                />
                {!["Foreign Currency", "ATM Cassette FC"].includes(
                  containerType
                ) ? (
                  <FormCombobox
                    form={form}
                    data={currencies.map((item: Currency) => ({
                      label: item?.name,
                      value: item?.shortName
                    }))}
                    name="currency"
                    label="Currency"
                    placeholder="Select Currency"
                    onChange={handleChangeCurrency}
                    disabled={isCurrencyDisabled.current}
                  />
                ) : null}

                {containerType === "Cheques" ? (
                  <FormField
                    control={form.control}
                    name="chequePieces"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Count</FormLabel>
                        <FormControl>
                          <NumericTextBox
                            step={0}
                            spinners={false}
                            min={1}
                            className="w-full h-10"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                ) : null}

                {consignmentType === "Coins" ? (
                  <>
                    <FormSelect
                      form={form}
                      data={
                        containerType === "Coins Box"
                          ? BOX_COINS_DENOMINATIONS
                          : BAG_COINS_DENOMINATIONS
                      }
                      name="details"
                      label="Coin Denomination"
                      placeholder="Select Denomination"
                    />
                    <FormField
                      control={form.control}
                      name="count"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Count</FormLabel>
                          <FormControl>
                            <NumericTextBox
                              step={0}
                              spinners={false}
                              min={1}
                              className="w-full h-10"
                              {...field}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </>
                ) : (
                  <>
                    {!["Foreign Currency", "ATM Cassette FC"].includes(
                      containerType
                    ) ? (
                      <FormField
                        control={form.control}
                        name="declaredValue"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel>Declared Value</FormLabel>
                            <FormControl>
                              <NumericTextBox
                                step={0}
                                spinners={false}
                                min={0}
                                format={
                                  containerType === "ATM Cassette FC"
                                    ? "n0"
                                    : "n2"
                                }
                                className="w-full h-10"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    ) : null}
                    <FormField
                      control={form.control}
                      name="sealNo"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Seal No.</FormLabel>
                          <FormControl>
                            <Input
                              type="text"
                              placeholder="Seal no."
                              {...field}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </>
                )}
                {isEdit ? (
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>Remarks</FormLabel>
                        <FormControl>
                          <Textarea className="resize-none" {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                ) : null}
                {["Foreign Currency", "ATM Cassette FC"].includes(
                  containerType
                ) ? (
                  <div className="w-full col-span-2">
                    <div className="grid grid-cols-[1fr_1fr_max-content]  items-end gap-3 mb-3">
                      <FormCombobox
                        form={form}
                        data={currencies.map((item: Currency) => ({
                          label: item?.name,
                          value: item?.shortName
                        }))}
                        name="currency"
                        label="Foreign Currency"
                        placeholder="Select Currency"
                        onChange={handleChangeCurrency}
                      />
                      <FormField
                        control={form.control}
                        name="declaredValue"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel>Declared Value</FormLabel>
                            <FormControl>
                              <NumericTextBox
                                step={0}
                                spinners={false}
                                min={0}
                                format="n0"
                                className="w-full h-10"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                      <Button
                        variant="secondary"
                        size="icon"
                        type="button"
                        onClick={handleMultipleCurrencyAppend}
                      >
                        <PlusCircle />
                      </Button>
                    </div>
                    <Grid data={fields} className="my-3">
                      <GridColumn field="currency" title="Currency" />
                      <GridColumn
                        field="declaredValue"
                        title="Value"
                        format="{0:N2}"
                      />
                      <GridColumn field="exchangeRate" title="Exchange Rate" />
                      <GridColumn
                        field="deleteId"
                        title="Remove"
                        cell={DeleteCell}
                      />
                    </Grid>
                    {form.formState.errors.packedCurrencies ? (
                      <i className="text-sm text-red-500">
                        *{form.formState.errors.packedCurrencies?.message}
                      </i>
                    ) : null}
                  </div>
                ) : null}

                <div className="flex gap-2 justify-end col-span-2">
                  <Button variant="secondary" type="submit">
                    {isEdit ? "Update Bag" : "Add Bag"}
                  </Button>
                </div>
              </form>
            </Form>
            <Grid data={consignments} className="my-3">
              {isTGDelivery ? (
                <GridColumn
                  field="sourceSPId"
                  title="Source Location"
                  cell={({ dataItem }) => (
                    <td>
                      {dataItem?.sourceLocationBarcode}-
                      {dataItem?.sourceLocationName}
                    </td>
                  )}
                />
              ) : null}
              <GridColumn
                field="containerType"
                title="Bag Type"
                width="155px"
              />
              <GridColumn field="details" title="Details" width="90px" />
              <GridColumn field="currency" title="Currency" width="90px" />
              <GridColumn field="declaredValue" title="Value" format="{0:N2}" />
              <GridColumn
                field="count"
                width="70px"
                title="Count"
                cell={({ dataItem }) => (
                  <td>{dataItem?.chequePieces || dataItem?.count}</td>
                )}
              />
              <GridColumn field="sealNo" title="Seal No" />
              <GridColumn
                field="deleteId"
                title="Action"
                width="75px"
                cell={ActionCell}
              />
            </Grid>
            <div className="flex gap-2 justify-end col-span-2">
              <Button
                variant="outline"
                onClick={() => {
                  setOpenAddConsignment(false);
                  form.reset(defaultValues);
                  setConsignments([...bags]);
                }}
                type="button"
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                variant="secondary"
                type="button"
                isLoading={isLoading}
                disabled={isLoading}
                onClick={onAssignBags}
              >
                Save
              </Button>
            </div>
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </div>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { label: string; value: string | number }[];
  onChange?: (e: string) => void;
  disabled?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as string}
            disabled={disabled}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={String(item.value)}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
